import Category from './Category';
import MetaData from './MetaData';
import ParentalControl from './ParentalControl';

export default class NodePreview {
    name: string = '';
    color: string = '';
    icon?: Category;
    metadata: MetaData[] = [];
    parental: ParentalControl = new ParentalControl();
}